import { FETCH_PROJECTS, CREATE_PROJECT, UPDATE_PROJECT, DESTROY_PROJECT, CREATE_MEMBER, DESTROY_MEMBER, CREATE_DOMAIN, UPDATE_DOMAIN, DESTROY_DOMAIN, LOGOUT } from '../actions/actionTypes.js';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';

const initialState = []

export const projects = (state = initialState, action) => {
  let idx;
  let project;
  let didx;
  
  switch (action.type) {
    case FETCH_PROJECTS.SUCCESS:
      return action.payload.projects || initialState
      // return keyBy(action.payload.projects || [], 'id');
    case FETCH_PROJECTS.UNLOAD:
      return initialState;
    case CREATE_PROJECT.SUCCESS:
      idx = findIndex(state, {id: action.payload.id})
      if (idx >= 0)
        return state;
      
      return [
        ...state,
        action.payload
      ];
    case UPDATE_PROJECT.SUCCESS:
      idx = findIndex(state, {id: action.payload.id})
      project = state[idx];
      return idx < 0 ? state : [
        ...state.slice(0, idx),
        {...project, ...action.payload},
        ...state.slice(idx + 1)
      ];
    case DESTROY_PROJECT.SUCCESS:
      idx = findIndex(state, {id: action.payload.id});
      if (idx < 0)
        return state;
      
      return [
        ...state.slice(0, idx),
        ...state.slice(idx + 1)
      ];
    case CREATE_MEMBER.SUCCESS:
      idx = findIndex(state, {id: action.payload.project_id})
      project = state[idx]
      
      return idx < 0 || !project ? state : [
        ...state.slice(0, idx),
        {...project, members: [
          ...project.members,
          action.payload
        ]},
        ...state.slice(idx + 1)
      ];
    case DESTROY_MEMBER.SUCCESS:
      idx = findIndex(state, {id: action.payload.project_id})
      project = state[idx]
      const midx = findIndex(project.members, {id: action.payload.id})
      
      return idx < 0 || !project ? state : [
        ...state.slice(0, idx),
        {...project, members: [
          ...project.members.slice(0, midx),
          ...project.members.slice(midx + 1)
        ]},
        ...state.slice(idx + 1)
      ];
    case CREATE_DOMAIN.SUCCESS:
      idx = findIndex(state, {id: action.payload.project_id})
      project = state[idx]
      
      return idx < 0 || !project ? state : [
        ...state.slice(0, idx),
        {...project, domains: [
          ...filter(project.domains, ({id}) => (id !== action.payload.id)),
          action.payload
        ]},
        ...state.slice(idx + 1)
      ];
    case UPDATE_DOMAIN.SUCCESS:
      idx = findIndex(state, {id: action.payload.project_id})
      project = state[idx]
      didx = findIndex(project.domains, {id: action.payload.id})
      
      return idx < 0 || !project ? state : [
        ...state.slice(0, idx),
        {...project, domains: [
          ...project.domains.slice(0, didx),
          action.payload,
          ...project.domains.slice(didx + 1)
        ]},
        ...state.slice(idx + 1)
      ];
    case DESTROY_DOMAIN.SUCCESS:
      idx = findIndex(state, {id: action.payload.project_id})
      project = state[idx]
      didx = findIndex(project.domains, {id: action.payload.id})
      
      return idx < 0 || !project ? state : [
        ...state.slice(0, idx),
        {...project, domains: [
          ...project.domains.slice(0, didx),
          ...project.domains.slice(didx + 1)
        ]},
        ...state.slice(idx + 1)
      ];
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/projects.js